/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 13275:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Variations = __webpack_require__(94416);
module.exports = Variations;

/***/ }),

/***/ 94416:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(84271);
__webpack_require__(79562);
__webpack_require__(65562);
__webpack_require__(83790);
__webpack_require__(65347);
__webpack_require__(45128);
__webpack_require__(61000);
var Variations = function Variations(_ref) {
  var render = _ref.render,
    json = _ref.json,
    schema = _ref.schema;
  if (!json || Object.keys(json).length === 0) {
    throw new Error('Component JSON must be defined and non empty');
  }
  var variations = json.variations.split('-');
  var VariationsComponent = variations.reduce(function (beforeValue, currentValue) {
    return beforeValue[currentValue];
  }, schema);
  if (VariationsComponent) {
    return render({
      Variation: VariationsComponent.component
    });
  }
  return null;
};
module.exports = Variations;

/***/ }),

/***/ 65562:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.reduce.js");

/***/ }),

/***/ 84271:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.error.cause.js");

/***/ }),

/***/ 79562:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.error.to-string.js");

/***/ }),

/***/ 83790:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.iterator.constructor.js");

/***/ }),

/***/ 65347:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.iterator.reduce.js");

/***/ }),

/***/ 45128:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.object.keys.js");

/***/ }),

/***/ 61000:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.object.to-string.js");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(13275);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.production.js.map